<template>
  <button class="hm-button" :style="{background, color}">
    <span v-if="loading" aria-hidden="true" class="hm-button__spinner"></span>
    <slot v-else />
  </button>
</template>

<script>
export default {
  name: 'HMButton',
  props: {
    background: {
      type: String,
      default: 'linear-gradient(180deg, #E3E8D9 0%, #DCE4CD 100%)',
    },
    color: {
      type: String,
      default: '#698262',
    },
    loading: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style>
.hm-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 57px;
  height: 36px;
  padding: 5px 12px;
  border-radius: 8px;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  line-height: 1;
  font-weight: 500;
  transition: filter 0.3s;

  &:hover {
    filter: brightness(0.95);
  }

  &[disabled] {
    opacity: 0.6;
    pointer-events: none;
  }
}

.hm-button__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #d5d4d4;
  border-top-color: #6ec1ff;
  border-radius: 50%;
  animation: hc-spin .8s linear infinite;
}

@keyframes hc-spin {
  to {
    transform: rotate(360deg)
  }
}
</style>